import { confirm } from "../../../components/Confirm";

export const openChartDeleteConfirm = async (title) => {
    return confirm({
        icon: true,
        text: `Please confirm deletion of "${title}"?`
    });
};